import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";
import { PATH_AUTH } from "src/routes/paths";

const GetStartedTitle = () => {
  const smUp = useResponsive("up", "sm");
  const { translate } = useLocales();

  return (
    smUp && (
      <Typography variant="body2" sx={{ mt: { md: -2 } }}>
        {translate("auth.login.signupPrompt")} &nbsp;&nbsp;
        <Link
          variant="subtitle2"
          component={RouterLink}
          to={PATH_AUTH.register}
        >
          {translate("auth.login.getStarted")}
        </Link>
      </Typography>
    )
  );
};

export default GetStartedTitle;
